import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  useTheme,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Alert,
  IconButton,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import WhiteTooltip from "../../components/WhiteTooltip";
import AgGridTable from "../../components/table/AgGridTable";
import {
  ColDef,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IRowNode,
} from "ag-grid-community";
import { useState, useEffect, useCallback, useMemo } from "react";
import axiosInstance from "../../axios/axios";
import Exclamation from "../../assets/Exclamation.png";
import AcceptedRiskTrue from "../../assets/accepted_risk_true.svg";
import AcceptedRiskFalse from "../../assets/risk_acceptance_false.svg";
import CiscoLogo_dark from "../../assets/cisco_dark.svg";
import PaloaltoLogo_dark from "../../assets/palaoto_dark.svg";
import AristaLogo_dark from "../../assets/arista_dark.svg";
import JuniperLogo_dark from "../../assets/juniper_dark.svg";
import CiscoLogo from "../../assets/cisco.svg";
import PaloaltoLogo from "../../assets/paloalto.svg";
import AristaLogo from "../../assets/arista.svg";
import True_img from "../../assets/baseVersion/True_img.svg";
import Not_Applicable from "../../assets/baseVersion/NotApplicable.svg";
import False_img from "../../assets/baseVersion/False_img.svg";
import JuniperLogo from "../../assets/juniper.svg";
import { toast } from "react-toastify";
//Arista: isDarkMode ? arista_dark : aristaLogo,
import aristaLogo from "../../assets/arista-assets.svg";
import arista_dark from "../../assets/arista-white.svg";
import useRolePermissions from "../../shared/hooks/useRolePermissions";
import { ROLES_CONTENT_PROPS } from "../../shared/constants/constant-data";
import fortinet from "../../assets/fortinet.svg"
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg"
import sophosLogo from "../../assets/sophos.svg";
import sophos_dark from "../../assets/sophos-white.svg";
import Windows_light from "../../assets/baseVersion/Windows_light.svg";
import Windows_dark from "../../assets/baseVersion/Windows_dark.svg";
import ubuntu from "../../assets/ubuntu.svg";
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../assets/ubuntu_white.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";
import AWS_img from "../../assets/baseVersion/aws.svg";
import AWS_DARK from "../../assets/baseVersion/AWS_DARK.svg";
import azure_img from "../../assets/baseVersion/azure.svg";
import azure_white from "../../assets/baseVersion/azure_white.svg";
import gcp_img from "../../assets/baseVersion/gcp.svg";
import gcp_dark from "../../assets/baseVersion/dark_agent_gcp.svg";


import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
interface AdminUser {
  id: string;
  firstname?: string;
  first_name?: string;
  name?: string;
  organization_email?: string;
  email?: string;
  role?: string;
  role_name?: string;
  [key: string]: any;
}

interface AssetRowData {
  id: string | number;
  whitelist_id?: string;
  hostname: string;
  vendor?: string;
  model?: string;
  accepted_count: number;
  assets?: boolean | null;
  accepted_risk?: boolean | null;
  status?: string;
  expiry_date?: string | null;
  resources_type?: string | null;
}

interface RiskDetailsDrawerProps {
  selectedRisk?: any;
  onAcceptSuccessRiskDetail?: () => void;
  onAcceptSuccessRiskHistory?: () => void;
  setIsSeeDetailsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const isHostnameNotFound = (hostname?: string | null) =>
  String(hostname ?? "").trim().toLowerCase() === "not found";

const isCloudAssetSelectable = (module: string | undefined, hostname?: string | null) =>
  !(module === "cloud" && isHostnameNotFound(hostname));

const RiskDetailsDrawer = ({
  selectedRisk,
  onAcceptSuccessRiskDetail,
  onAcceptSuccessRiskHistory,
  setIsSeeDetailsOpen,
}: RiskDetailsDrawerProps) => {
  console.log("Selected row in RiskDetailsDrawer:", selectedRisk);
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const [rowData, setRowData] = useState<AssetRowData[]>([]);
  const [selectedRows, setSelectedRows] = useState<AssetRowData[]>([]);
  const [selectedCount, setSelectedCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const [comment, setComment] = useState("");
  const [validityDays, setValidityDays] = useState<number | string>(60);
  const [adminUsers, setAdminUsers] = useState<AdminUser[]>([]);
  const [isAdminLoading, setIsAdminLoading] = useState(false);
  const [openExtendDialog, setOpenExtendDialog] = useState(false);
  const [extendRow, setExtendRow] = useState<AssetRowData | null>(null);
  const [extendDays, setExtendDays] = useState<number>(30);
  const [extendComment, setExtendComment] = useState("");
  const [isExtending, setIsExtending] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { hasPermissions } = useRolePermissions();
  const canSelect = true;

  const hasAcceptedDevices = useMemo(() => {
    return selectedRows.some(
      (row) => row?.accepted_risk === true || (row?.accepted_risk as any) === 1
    );
  }, [selectedRows]);

  const hasUnacceptedDevices = useMemo(() => {
    return selectedRows.some(
      (row) => row?.accepted_risk !== true && (row?.accepted_risk as any) !== 1
    );
  }, [selectedRows]);

  const isMixedSelection = useMemo(() => {
    return hasAcceptedDevices && hasUnacceptedDevices;
  }, [hasAcceptedDevices, hasUnacceptedDevices]);

  const shouldShowRiskValidity = useMemo(() => {
    return hasUnacceptedDevices;
  }, [hasUnacceptedDevices]);

  const fetchAdminUsers = useCallback(async () => {
    setIsAdminLoading(true);
    try {
      const payload = { type: 1 };
      const response = await axiosInstance.post("authentication/org-users", payload);

      const users: any[] =
        response.data?.data?.users_list ||
        response.data?.users_list ||
        (Array.isArray(response.data?.data) ? response.data.data : []) ||
        [];

      const admins = users.filter((user: any) => {
        const role = String(
          user.role ||
          user.role_name ||
          (typeof user.role === "object" ? user.role?.name : "") ||
          ""
        ).toLowerCase().trim();
        return role.includes("admin");
      });

      setAdminUsers(admins);
    } catch (error) {
      console.error("Error fetching admin users:", error);
      setAdminUsers([]);
    } finally {
      setIsAdminLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAdminUsers();
  }, [fetchAdminUsers]);

  const fetchAssets = useCallback(async () => {
    const id = selectedRisk?.id ?? selectedRisk?.parameter_name_id ?? selectedRisk?.parameter_id;
    if (!id) {
      setRowData([]);
      return;
    }
    setIsLoading(true);
    try {
      const response = await axiosInstance.get("securityscan/assets", {
        params: {
          module: selectedRisk?.module || "on_premise",
          parameter_name_id: id,
        },
      });

      let mappedData: AssetRowData[] = [];

      if (response.data?.data) {
        mappedData = response.data.data.map((item: any): AssetRowData => {
          const row: AssetRowData = {
            id: item.device_id,
            whitelist_id: item.id || item.whitelist_id || undefined,
            hostname: item.host_name,
            vendor:
              item.vendor ? item.vendor.charAt(0).toUpperCase() + item.vendor.slice(1) : "-",
            model: item.device_model || "-",
            accepted_count: item.accepted_risk ?? 0,
            assets: item.compliance === 1 || item.compliance === "1"
              ? "pass"
              : item.compliance === 0 || item.compliance === "0"
                ? "fail"
                : item.compliance === 2 || item.compliance === "2" || item.compliance === 3 || item.compliance === "3"
                  ? "not applicable"
                  : item.compliance,
            accepted_risk: item.accepted_risk,
            status: item.approval_status || undefined,
            expiry_date: item.expiry_date || null,
            resources_type: item.resources_type || item.device_type || null,
          };
          return row;
        });
        setRowData(mappedData);
      } else {
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching assets in RiskDetailsDrawer:", error);
    } finally {
      setIsLoading(false);
    }
  }, [selectedRisk?.id, selectedRisk?.parameter_name_id, selectedRisk?.parameter_id]);

  useEffect(() => {
    setSelectedRows([]);
    setSelectedCount(0);
    setComment("");
    setSelectedAdmin("");
    setOpenDialog(false);
    fetchAssets();
  }, [fetchAssets, selectedRisk]);

  const columnDefs: ColDef[] = useMemo(() => [
    {
      field: "selection",
      headerName: "",
      maxWidth: 50,
      checkboxSelection: (params) =>
        isCloudAssetSelectable(selectedRisk?.module, params.data?.hostname),
      showDisabledCheckboxes: false,
      headerCheckboxSelection: true,
      pinned: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMovable: true,
      lockPosition: true,
      lockPinned: true,
      suppressSizeToFit: true,
    },
    {
      field: "vendor",
      headerName: "Vendor",
      width: 120,
      filter: false,
      cellRenderer: (params: any) => {
        const vendorLogos: any = {
          cisco: isDarkMode ? CiscoLogo_dark : CiscoLogo,
          paloalto: isDarkMode ? PaloaltoLogo_dark : PaloaltoLogo,
          arista: isDarkMode ? arista_dark : aristaLogo,
          juniper: isDarkMode ? JuniperLogo_dark : JuniperLogo,
          fortinet: isDarkMode ? fortinet : fortinet,
          sophos: isDarkMode ? sophos_dark : sophosLogo,
          ubuntu: isDarkMode ? ubuntu_dark : ubuntu_light,
          microsoft: isDarkMode ? Windows_dark : Windows_light,
          debian: isDarkMode ? debian_dark : debian,
          redhat: isDarkMode ? redhat_dark : redhat_light,
          huawei: isDarkMode ? huawei_dark : huawei_light,
          mikrotik: isDarkMode ? mikrotik_dark : mikrotik,
          edgecore: edgecore_logo,
          "tp-link": isDarkMode ? tplink_dark : tplink_light,
          tplink: isDarkMode ? tplink_dark : tplink_light,
          apple: isDarkMode ? apple_dark : apple_img,
          macos: isDarkMode ? apple_dark : apple_img,
          dell: dell_logo,
          amazonwebservices: isDarkMode ? AWS_DARK : AWS_img,
          aws: isDarkMode ? AWS_DARK : AWS_img,
          microsoftazure: isDarkMode ? azure_white : azure_img,
          azure: isDarkMode ? azure_white : azure_img,
          googlecloudplatform: isDarkMode ? gcp_dark : gcp_img,
          googlecloud: isDarkMode ? gcp_dark : gcp_img,
          gcp: isDarkMode ? gcp_dark : gcp_img,
          syrotech: isDarkMode ? syrotech_dark : syrotech_light,
        };

        const normalizedVendor = params.value?.toLowerCase().replace(/\s/g, "");
        const logoSrc = vendorLogos[normalizedVendor];

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "100%",
              paddingLeft: "5px",
            }}
          >
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={params.value}
                style={{
                  maxWidth: "80px",
                  height: normalizedVendor === "huawei" ? "30px" : "24px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <span>{params.value}</span>
            )}
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: selectedRisk?.module === "cloud" ? "resources_type" : "model",
      headerName: selectedRisk?.module === "cloud" ? "Resource Type" : "OS",
      width: 140,
      filter: false,
      valueGetter: (params: any) => {
        if (selectedRisk?.module === "cloud") {
          return params.data?.resources_type || "-";
        }
        return params.data?.model || "-";
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "hostname",
      headerName: "Host Name",
      flex: 1,
      filter: false,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      width: 140,
      filter: false,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: "100%" }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography variant="body2" fontWeight={600}>{params.value}</Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <img src={AcceptedRisk_False} alt="warning" style={{ height: "20px" }} />
          </Box>
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },

    {
      field: "assets",
      headerName: "Compliance",
      width: 110,
      filter: false,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      cellRenderer: (params: any) => {
        let imgSrc;
        let altText;

        switch (params.value) {
          case "pass":
          case 1:
          case "1":
            imgSrc = True_img;
            altText = "Pass";
            break;
          case "fail":
          case 0:
          case "0":
            imgSrc = False_img;
            altText = "Fail";
            break;
          case "not applicable":
          case "manual":
          case 2:
          case "2":
          case 3:
          case "3":
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
            break;
          default:
            imgSrc = Not_Applicable;
            altText = "Not Applicable";
        }

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{ width: 20, height: 20 }}
            />
          </Box>
        );
      },
    },
    {
      field: "expiry_date",
      headerName: "Expiry Date",
      width: 200,
      filter: false,
      cellRenderer: (params: any) => {
        const expiryDate = params.value
          ? String(params.value).split(/[T ]/)[0]
          : "-";
        const rowStatus = String(params.data?.status || params.data?.approval_status || "").trim().toUpperCase();
        const isExpired = rowStatus.includes("EXPIR") || rowStatus.includes("EXPIER");
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              height: "100%",
            }}
          >
            <Typography variant="body2" sx={{ fontSize: "13px" }}>
              {expiryDate}
            </Typography>
            {params.value && !isExpired && !rowStatus.includes("PENDING") && (
              <IconButton
                size="small"
                aria-label="Extend expiry date"
                onClick={(event) => {
                  event.stopPropagation();
                  handleOpenExtendDialog(params.data);
                }}
                sx={{
                  color: isDarkMode ? "#90caf9" : "#2f2bcf",
                  padding: "2px",
                }}
              >
                <AddBoxIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 110,
      filter: false,
      cellRenderer: (params: any) => {
        const rawStatus = params.value || params.data?.approval_status;
        if (!rawStatus) return null;

        const statusUpper = String(rawStatus).trim().toUpperCase();

        const isApproved =
          statusUpper.includes("APPROV") || statusUpper.includes("ACCEPT");
        const isRejected = statusUpper.includes("REJECT");
        const isPending = statusUpper.includes("PEND");
        const isExpired = statusUpper.includes("EXPIR") || statusUpper.includes("EXPIER");

        if (!isApproved && !isRejected && !isPending && !isExpired) {
          return null;
        }

        const displayLabel = isApproved
          ? "APPROVED"
          : isRejected
          ? "REJECTED"
          : isPending
          ? "PENDING"
          : "EXPIRED";

        return (
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <Chip
              label={displayLabel}
              size="small"
              sx={{
                fontWeight: 600,
                fontSize: "11px",
                height: "22px",
                bgcolor: isApproved
                  ? isDarkMode ? "rgba(46, 125, 50, 0.2)" : "rgba(46, 125, 50, 0.12)"
                  : isPending
                  ? isDarkMode ? "rgba(255, 152, 0, 0.2)" : "#FFF4E5"
                  : isExpired
                  ? isDarkMode ? "rgba(217, 45, 32, 0.2)" : "#FEE4E2"
                  : isDarkMode ? "rgba(211, 47, 47, 0.2)" : "rgba(211, 47, 47, 0.12)",
                color: isApproved
                  ? isDarkMode ? "#81C784" : "#2e7d32"
                  : isPending
                  ? isDarkMode ? "#FFB74D" : "#FF9800"
                  : isExpired
                  ? isDarkMode ? "#FF8A80" : "#D92D20"
                  : isDarkMode ? "#FF8A80" : "#d32f2f",
              }}
            />
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ], [canSelect, isDarkMode, selectedRisk?.module]);

  const handleSelectionChange = useCallback((selected: AssetRowData[]) => {
    const list = selected || [];
    setSelectedRows(list);
    setSelectedCount(list.length);
  }, []);

  const onGridReady = useCallback((params: GridReadyEvent) => {
    setGridApi(params.api);
  }, []);

  useEffect(() => {
    if (!gridApi || !rowData) {
      if (gridApi) gridApi.deselectAll();
      setSelectedCount(0);
      setSelectedRows([]);
      return;
    }

    const nodesToSelect: IRowNode<AssetRowData>[] = [];
    gridApi.forEachNode((node: IRowNode<AssetRowData>) => {
      if (
        node.data?.accepted_risk === true &&
        isCloudAssetSelectable(selectedRisk?.module, node.data?.hostname)
      ) {
        nodesToSelect.push(node);
      }
    });

    gridApi.deselectAll();

    if (nodesToSelect.length > 0) {
      gridApi.setNodesSelected({ nodes: nodesToSelect, newValue: true });

      const initialSelectedData = nodesToSelect
        .map((node) => node.data)
        .filter((data) => !!data);
      setSelectedRows(initialSelectedData);
      setSelectedCount(initialSelectedData.length);
    } else {
      setSelectedCount(0);
      setSelectedRows([]);
    }
  }, [rowData, gridApi, selectedRisk?.module]);

  const handleOpenDialog = () => {
    if (!selectedRows.length) return;
    setComment("");
    setSelectedAdmin("");
    setValidityDays(60);
    setOpenDialog(true);
    fetchAdminUsers();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenExtendDialog = (row: AssetRowData) => {
    setExtendRow(row);
    setExtendDays(30);
    setExtendComment("");
    setSelectedAdmin("");
    setOpenExtendDialog(true);
    fetchAdminUsers();
  };

  const handleCloseExtendDialog = () => {
    setOpenExtendDialog(false);
    setExtendRow(null);
    setExtendDays(30);
    setExtendComment("");
    setSelectedAdmin("");
  };

  const handleExtendExpiry = async () => {
    if (!extendRow) return;
    setIsExtending(true);
    try {
      const recordId = extendRow.whitelist_id || extendRow.id;
      const payload = {
        id: recordId,
        extend_days: extendDays,
        comment: extendComment,
        target_admin_id: selectedAdmin,
      };

      console.log("📤 [Extend Expiry] API Payload:", payload);

      const response = await axiosInstance.post(
        "securityscan/extend-accepted-risk",
        payload
      );

      console.log("📥 [Extend Expiry] API Response:", response.data);

      //toast.success(response.data?.message || "Expiry date extended successfully");Removed API toast as requested (keeping socket notification only for this action)
      handleCloseExtendDialog();
      await fetchAssets();

      if (onAcceptSuccessRiskDetail) {
        onAcceptSuccessRiskDetail();
      }
      if (onAcceptSuccessRiskHistory) {
        onAcceptSuccessRiskHistory();
      }
    } catch (error: any) {
      console.error("Error extending expiry:", error);
      toast.error(error?.response?.data?.message || "Failed to extend expiry date");
    } finally {
      setIsExtending(false);
    }
  };

  const handleAcceptRisk = async () => {
    const rowsToSubmit = selectedRows.filter((row) =>
      isCloudAssetSelectable(selectedRisk?.module, row.hostname)
    );
    if (!rowsToSubmit.length) return;
    setIsLoading(true);
    try {
      const parsedDays = Number(validityDays);
      const days = !isNaN(parsedDays) && parsedDays > 0 ? parsedDays : 60;
      const riskId = selectedRisk?.id ?? selectedRisk?.parameter_name_id ?? selectedRisk?.parameter_id;
      const payload: any = {
        id: riskId,
        state: 0,
        devices_ids: rowsToSubmit.map((row) => {
          const original = rowData.find((r) => String(r.id) === String(row.id));
          const isCurrentlyAccepted = original ? original.accepted_risk === true : row.accepted_risk === true;
          return {
            device_id: row.id,
            white_list: isCurrentlyAccepted ? false : true,
          };
        }),
        comments: comment,
        target_admin_id: selectedAdmin,
        accepted_for_days: shouldShowRiskValidity ? days : null,
      };

      console.log("====================================");
      console.log("📤 [Send Request] Whitelist API Payload:");
      console.log("Endpoint: POST securityscan/white-list");
      console.log("Payload Object:", payload);
      console.log("Payload JSON:\n" + JSON.stringify(payload, null, 2));
      console.log("====================================");

      const response = await axiosInstance.post(
        "securityscan/white-list",
        payload
      );

      console.log("📥 [Send Request] Whitelist API Response:", response.data);

      await fetchAssets();

      if (onAcceptSuccessRiskDetail) {
        onAcceptSuccessRiskDetail();
      }
      if (onAcceptSuccessRiskHistory) {
        onAcceptSuccessRiskHistory();
      }

      handleCloseDialog();
      setComment("");
      setSelectedAdmin("");
      setValidityDays(60);
      if (setIsSeeDetailsOpen) {
        setIsSeeDetailsOpen(false);
      }
    } catch (error: any) {
      console.error("Error accepting risk:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Define memoized grid options
  const gridOptions: GridOptions<AssetRowData> = useMemo(() => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      suppressMovable: false,
    },
    columnDefs: columnDefs,
    rowData: rowData,
    rowHeight: 48,
    headerHeight: 48,
    suppressCellFocus: true,
    rowStyle: { cursor: "default" },
    suppressRowClickSelection: true,
    rowMultiSelectWithClick: false,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    rowSelection: "multiple" as const,
    isRowSelectable: (node) =>
      isCloudAssetSelectable(selectedRisk?.module, node.data?.hostname),
    getRowId: (params) => String(params.data.id),
    onGridReady: onGridReady,
  }), [columnDefs, rowData, onGridReady, selectedRisk?.module]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        sx={{
          pb: 0,
          pl: 1,
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AgGridTable
          columnDefs={columnDefs}
          data={rowData}
          showSearch
          height="calc(100vh - 200px)"
          isRowSelectable={true}
          rowSelection="multiple"
          gridOptions={gridOptions}
          onSelectionChange={handleSelectionChange}
          isLoading={isLoading}
          checkboxSelection={true}
          headerCheckboxSelection={true}
        />
      </Box>

      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          borderTop: `1px solid ${isDarkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0"}`,
          bgcolor: isDarkMode ? "#191C24" : "#ffffff",
        }}
      >
        <Typography sx={{ color: isDarkMode ? "#D0D5DD" : "#666666", fontSize: "14px", fontWeight: 500 }}>
          {selectedCount}/{rowData.length} Devices Selected
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            sx={{
              minWidth: 100,
              bgcolor: "#E31B0C",
              "&:hover": { bgcolor: "#B81509" },
            }}
            onClick={handleOpenDialog}
            disabled={
              !selectedRows.length || isLoading
            }
          >
            Send Request
          </Button>

          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                position: "fixed",
                bottom: 20,
                right: 20,
                m: 0,
                borderRadius: "12px",
                boxShadow: isDarkMode ? "0px 8px 24px rgba(0, 0, 0, 0.5)" : "0px 8px 24px rgba(0, 0, 0, 0.15)",
                bgcolor: isDarkMode ? "#1E1E2D" : "#ffffff",
              },
            }}
          >
            <DialogTitle sx={{ pb: 2, borderBottom: `1px solid ${isDarkMode ? "rgba(255, 255, 255, 0.12)" : "#eaeaea"}` }}>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 0.5 }}>Send Request</Typography>
              <Typography variant="body2" color="text.secondary">Select an admin and provide a reason for this request.</Typography>
            </DialogTitle>
            <DialogContent sx={{ pt: 3, pb: 1 }}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="admin-select-label">Select Admin</InputLabel>
                <Select
                  labelId="admin-select-label"
                  id="admin-select"
                  value={selectedAdmin}
                  label="Select Admin"
                  onChange={(e) => setSelectedAdmin(e.target.value)}
                  disabled={isAdminLoading}
                >
                  {isAdminLoading ? (
                    <MenuItem disabled value="">
                      Loading admins...
                    </MenuItem>
                  ) : adminUsers.length === 0 ? (
                    <MenuItem disabled value="">
                      No admin users found
                    </MenuItem>
                  ) : (
                    adminUsers.map((admin) => {
                      const firstName = (
                        admin.firstname ||
                        admin.first_name ||
                        admin.firstName ||
                        admin.name ||
                        ""
                      ).trim();
                      const displayName =
                        firstName ||
                        admin.organization_email ||
                        admin.email ||
                        "Admin";
                      return (
                        <MenuItem key={admin.id} value={admin.id}>
                          {displayName}
                        </MenuItem>
                      );
                    })
                  )}
                </Select>
              </FormControl>

              {shouldShowRiskValidity && (
                <FormControl fullWidth margin="normal">
                  <InputLabel id="risk-validity-label">Risk Validity (Days)</InputLabel>
                  <Select
                    labelId="risk-validity-label"
                    id="risk-validity"
                    value={validityDays}
                    label="Risk Validity (Days)"
                    onChange={(e) => setValidityDays(Number(e.target.value))}
                  >
                    <MenuItem value={30}>30 Days</MenuItem>
                    <MenuItem value={60}>60 Days</MenuItem>
                    <MenuItem value={90}>90 Days</MenuItem>
                  </Select>
                </FormControl>
              )}

              <TextField
                margin="normal"
                id="comment"
                label="Comment (Required)"
                type="text"
                fullWidth
                variant="outlined"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                multiline
                rows={4}
                error={(comment.length > 0 && comment.length < 8) || (comment !== comment.trim())}
                helperText={
                  comment.length > 0 && comment.length < 8
                    ? "Comment must be at least 8 characters long"
                    : comment !== comment.trim()
                      ? "Spaces are not allowed at the beginning or end of the comment"
                      : ""
                }
              />

              {isMixedSelection && (
                <Alert severity="warning" sx={{ mt: 1.5, fontSize: "12px" }}>
                  <strong>Notice:</strong> Your selection includes accepted and unaccepted devices. Risk acceptance will be removed from accepted devices.
                </Alert>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 2, pb: 2, borderTop: `1px solid ${isDarkMode ? "rgba(255, 255, 255, 0.12)" : "#eaeaea"}` }}>
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                sx={{
                  borderColor: "#d3d3d3",
                  color: "#5c5c5c",
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 600,
                  px: 3,
                  "&:hover": { borderColor: "#b0b0b0", bgcolor: "#f5f5f5" }
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleAcceptRisk}
                variant="contained"
                disabled={
                  isLoading ||
                  !comment ||
                  !selectedAdmin ||
                  comment.length < 8 ||
                  comment !== comment.trim() ||
                  (shouldShowRiskValidity &&
                    (!validityDays ||
                      Number(validityDays) < 1 ||
                      Number(validityDays) > 90))
                }
                sx={{
                  bgcolor: "#E31B0C",
                  color: "#fff",
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 600,
                  px: 3,
                  "&:hover": { bgcolor: "#B81509" },
                  "&.Mui-disabled": { bgcolor: "#f5f5f5", color: "#bdbdbd" },
                }}
              >
                {isLoading ? <CircularProgress size={24} /> : "Send Request"}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>

      {/* Extend Expiry Dialog */}
      <Dialog
        open={openExtendDialog}
        onClose={handleCloseExtendDialog}
        sx={{
          '& .MuiDialog-paper': {
            width: '420px',
            maxWidth: '90vw',
            borderRadius: '10px',
            padding: '20px',
            boxSizing: 'border-box',
            overflow: 'hidden',
            backgroundColor: isDarkMode ? '#1E2330' : '#FFFFFF',
            boxShadow: isDarkMode
              ? '0px 8px 24px rgba(0, 0, 0, 0.5)'
              : '0px 8px 24px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogContent sx={{ padding: '0' }}>
          <Typography
            component="div"
            sx={{
              textAlign: 'center',
              fontWeight: 600,
              fontSize: '15px',
              lineHeight: 1.6,
              color: isDarkMode ? '#E5E7EB' : '#111827',
              py: 0.5,
            }}
          >
            Extend Expiry Date
          </Typography>
          {extendRow && (
            <Typography
              variant="body2"
              sx={{
                textAlign: 'center',
                color: isDarkMode ? '#9CA3AF' : '#6B7280',
                fontSize: '12px',
                mt: 0.5,
                mb: 1.5,
              }}
            >
              {extendRow.hostname} — Current expiry: {extendRow.expiry_date ? String(extendRow.expiry_date).split(/[T ]/)[0] : "-"}
            </Typography>
          )}

          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
            <InputLabel id="extend-days-label">Extension Period</InputLabel>
            <Select
              labelId="extend-days-label"
              id="extend-days-select"
              value={extendDays}
              label="Extension Period"
              onChange={(e) => setExtendDays(Number(e.target.value))}
            >
              <MenuItem value={30}>30 Days</MenuItem>
              <MenuItem value={60}>60 Days</MenuItem>
              <MenuItem value={90}>90 Days</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" margin="normal">
            <InputLabel id="extend-admin-select-label">Select Admin</InputLabel>
            <Select
              labelId="extend-admin-select-label"
              id="extend-admin-select"
              value={selectedAdmin}
              label="Select Admin"
              onChange={(e) => setSelectedAdmin(e.target.value)}
              disabled={isAdminLoading}
            >
              {isAdminLoading ? (
                <MenuItem disabled value="">
                  Loading admins...
                </MenuItem>
              ) : adminUsers.length === 0 ? (
                <MenuItem disabled value="">
                  No admin users found
                </MenuItem>
              ) : (
                adminUsers.map((admin) => {
                  const firstName = (
                    admin.firstname ||
                    admin.first_name ||
                    admin.firstName ||
                    admin.name ||
                    ""
                  ).trim();
                  const displayName =
                    firstName ||
                    admin.organization_email ||
                    admin.email ||
                    "Admin";
                  return (
                    <MenuItem key={admin.id} value={admin.id}>
                      {displayName}
                    </MenuItem>
                  );
                })
              )}
            </Select>
          </FormControl>

          <TextField
            margin="normal"
            id="extend-comment"
            label="Comment (Required)"
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            value={extendComment}
            onChange={(e) => setExtendComment(e.target.value)}
            multiline
            rows={3}
            error={(extendComment.length > 0 && extendComment.length < 8) || (extendComment !== extendComment.trim())}
            helperText={
              extendComment.length > 0 && extendComment.length < 8
                ? "Comment must be at least 8 characters long"
                : extendComment !== extendComment.trim()
                  ? "Spaces are not allowed at the beginning or end"
                  : ""
            }
          />
        </DialogContent>
        <DialogActions sx={{ padding: '14px 0 0 0', gap: '10px', display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            onClick={handleCloseExtendDialog}
            disabled={isExtending}
            fullWidth
            sx={{
              height: '34px', borderRadius: '6px', textTransform: 'none', fontWeight: 600, fontSize: '13px',
              borderColor: isDarkMode ? '#4A5568' : '#d1d5db', color: isDarkMode ? '#D1D5DB' : '#374151',
              '&:hover': { borderColor: isDarkMode ? '#718096' : '#9ca3af', backgroundColor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)' },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleExtendExpiry}
            disabled={
              isExtending ||
              !selectedAdmin ||
              !extendComment ||
              extendComment.length < 8 ||
              extendComment !== extendComment.trim()
            }
            fullWidth
            sx={{
              height: '34px', borderRadius: '6px', textTransform: 'none', fontWeight: 600, fontSize: '13px',
              bgcolor: '#4640DE', color: '#FFFFFF', boxShadow: 'none',
              '&:hover': { bgcolor: '#3730CC', boxShadow: 'none' },
              '&:disabled': { backgroundColor: isDarkMode ? '#3D3D4E' : '#E5E7EB', color: isDarkMode ? '#7D7D8E' : '#9CA3AF' },
            }}
          >
            {isExtending ? 'Extending...' : 'Extend'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RiskDetailsDrawer;
